export const books = {
  home: "/",
  savedPost: "saved-post",
  leaderboard: "leaderboard",
  trending: "trending",
  watchlist: "watchlist",
  privacyPolicy: "privacy-policy",
  contactUs: "contact-us",
  settings: "settings",
  settingsAccount: "information",
  changeUsername: "change-username",
  changeEmaill: "change-email",
  yourAccount: "account",
  confirmPassword: "confirm-password",
  premium: "premium",
  deactivateYourAccount: "deactivate-your-account",
  walletSettings: "wallet",
  withdrawalAddresses: "withdrawal-addresses",
  manageNotifications: "manage-notifications",
  post: "post/:uid",
  settingsChangePassword: "change-password",
  // settingsWallet: "/wallet",
  // settingsPremium: "/premium",
  notifications: "notifications",
  // settingsDeactivateAccount: "/deactivate-account",
  login: "/login",
  signUp: "/signup",
  forgotPassword: "/forgot-password",
  profile: "/profile/:uid",
  purchased: "/purchased",
  conversations: "/conversations",
  wallet: "/wallet",
  stock: "/stock/:symbol",
  drafts: "/drafts",
  comingSoon: "coming-soon",
  likePrice: "like-price",
  subscription: "subscription",
  faq: "faq",
};
